import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import HeaderViewComponent from '../components/Header/HeaderView';
import {bindActionCreators} from 'redux';
import * as languageActions from "../actions/languageActions";
import * as userActions from "../actions/userActions";
import AuthModalLayout from './Customer/AuthModal';
import * as restaurantActions from "../actions/restaurantActions";
import {List} from "immutable";
import Spinner from "../components/Spinner/Spinner";
import {translate} from 'react-i18next';


class HeaderLayout extends Component {

  static renderLoading(t) {
    return (
      <Spinner text={t('loading_restaurants')} />
    );
  }

  render() {
    const {restaurants, setLanguage, language, userState, exitCustomer, openAuthModal, selectedRestaurant,
      startSelectedFetchRestaurant, endSelectedFetchRestaurant, t} = this.props;
    if (!List.isList(restaurants.list)) return HeaderLayout.renderLoading(t);
    const authModalOpened = userState.get('authModalOpened');
    let id = restaurants.selectedId;
    if (id) {
      let restaurantFromLocalStorage = restaurants.list.find(obj => {
        return obj.id === restaurants.selectedId;
      });
      if (restaurantFromLocalStorage.now_is_closed || restaurantFromLocalStorage.now_is_unavailable) {
        id = null;
      }
    }
    const selected = {
      ...restaurants.item,
      'id': id
    };
    return (
      <HeaderViewComponent
        selected={selected}
        setLanguage={setLanguage}
        language={language}
        user={userState.get('profile')}
        exitCustomer={exitCustomer}
        openAuthModal={openAuthModal}
        selectedRestaurant={selectedRestaurant}
        startSelectedFetchRestaurant={startSelectedFetchRestaurant}
        endSelectedFetchRestaurant={endSelectedFetchRestaurant}
        restaurants={restaurants.list}
      >
        {authModalOpened &&
        <div className='login'>
          <AuthModalLayout/>
          <div className="login__picture">
          </div>
        </div>}
      </HeaderViewComponent>
    );
  }
}


HeaderLayout.propTypes = {
  restaurants: PropTypes.object,
  setLanguage: PropTypes.func,
  exitCustomer: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    restaurants: state.restaurants,
    language: state.language,
    userState: state.user,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    setLanguage: bindActionCreators(languageActions.setLanguage, dispatch),
    exitCustomer: bindActionCreators(userActions.exitCustomer, dispatch),
    openAuthModal: bindActionCreators(userActions.openAuthModal, dispatch),
    selectedRestaurant: bindActionCreators(restaurantActions.selectedRestaurant, dispatch),
    startSelectedFetchRestaurant: bindActionCreators(restaurantActions.startSelectedFetchRestaurant, dispatch),
    endSelectedFetchRestaurant: bindActionCreators(restaurantActions.endSelectedFetchRestaurant, dispatch),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(translate('translations')(HeaderLayout)));


// WEBPACK FOOTER //
// ./src/containers/Header.js